import { render, staticRenderFns } from "./CrewBiodata.vue?vue&type=template&id=5e2d177f&scoped=true&"
import script from "./CrewBiodata.vue?vue&type=script&lang=js&"
export * from "./CrewBiodata.vue?vue&type=script&lang=js&"
import style0 from "./CrewBiodata.vue?vue&type=style&index=0&id=5e2d177f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d177f",
  null
  
)

export default component.exports